<template>
  <transition name="slide-fade" mode="out-in" appear>
    <router-view />
  </transition>
</template>

<script>
export default {
  name: 'RouterViewBody',
  components: {},
}
</script>
